import { useState, useEffect } from "react";
import { Modal, Button, message, Table } from "antd";
import request from "../../util/request";

const PointsModal = (props) => {
  const { title, visible, loading, footer, closeDialog, data } = props;
  const [btnLoading, setBtnLoading] = useState(false);

  const [detailData, setDetailData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);

  const getDetailData = async () => {
    setBtnLoading(true);
    try {
      const res = await request.get(
        `/api/xcx-user/parent/list?number=${data.userId}&pageNum=${pageNum}&pageSize=${pageSize}`
      );
      setDetailData(res?.list || []);
      setTotal(res?.total || 0);
    } catch (error) {
      message.error(error?.message);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleCloseDialog = (status) => {
    setPageSize(10);
    setPageNum(1);
    closeDialog(status);
  };

  useEffect(() => {
    if (visible && title === "查看个人明细") {
      getDetailData();
    }
  }, [visible, pageSize, pageNum]);

  if (title === "发放确认") {
    const handleOk = async () => {
      setBtnLoading(true);
      try {
        let url = "/api/xcx-user/parent/distributeRecommend";
        let req = { totalPoints: Number(data.points) };
        if (data.type === "member") {
          url = "/api/xcx-user/parent/memberassignPoints";
        } else if (data.type === "user") {
          url = "/api/xcx-user/parent/addRecommendReward";
          req = {
            userId: data.userId,
            num: Number(data.points),
          };
        }
        await request.post(url, req);
        message.success("操作成功");
        if (data.type === "user") {
          handleCloseDialog("success");
        } else closeDialog();
      } catch (error) {
        message.error(error?.message);
      } finally {
        setBtnLoading(false);
      }
    };

    return (
      <div>
        <Modal
          title={title}
          open={visible}
          onCancel={closeDialog}
          loading={loading}
          footer={[
            <Button key="back" onClick={closeDialog}>
              取消
            </Button>,
            <Button
              key="submit"
              loading={btnLoading}
              type="primary"
              onClick={handleOk}
            >
              确认
            </Button>,
          ]}
        >
          <div
            className="modalF"
            style={{ margin: "32px 0", textAlign: "center" }}
          >
            <span>
              本次共发放用户<strong>{data.total}</strong>人，
              {data.type === "user" ? "" : "总"}积分
              <strong>{data.points}</strong>
            </span>
          </div>
        </Modal>
      </div>
    );
  } else if (title === "查看个人明细") {
    const columns = [
      { title: "名称", dataIndex: "description" },
      { title: "时间", dataIndex: "createTime" },
      { title: "积分", dataIndex: "num", width: 100 },
    ];

    return (
      <div>
        <Modal
          width={700}
          centered
          className="table-modal"
          title={title}
          open={visible}
          onCancel={handleCloseDialog}
          loading={loading}
          footer={[]}
        >
          <div className="table" style={{ padding: 0 }}>
            <Table
              sticky
              scroll={{ x: "max-content", y: "calc(100vh - 234px)" }}
              columns={columns}
              dataSource={detailData}
              pagination={{
                current: pageNum,
                pageSize: pageSize,
                total,
                onChange: (pageNum, pageSize) => {
                  setPageNum(pageNum);
                  setPageSize(pageSize);
                },
                showSizeChanger: true,
                showTotal: (total) => `共 ${total} 条数据`,
                pageSizeOptions: ["10", "20", "50", "100"],
                loading: btnLoading,
              }}
              loading={btnLoading}
              rowKey="id"
            />
          </div>
        </Modal>
      </div>
    );
  }
};

export default PointsModal;
